import React, { Fragment, useState } from 'react';
import * as PropTypes from 'prop-types';

import AppointmentHeader from '../Components/AppointmentHeader';
import TimeSlots from '../Components/TimeSlots';
import Shape from '../../common/Shape';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import BackButton from '../../common/BackButton';
import Button from '../../Button';

import { usePageView } from '../../../hocs/usePageView';

import { enhance } from './enhance';

import { redirectToAppointmentOverview } from '../../../utils/appointments/redirect-utils';

import styles from './styles.styl';

function AvailableTimeSlots({
  formatMessage,
  timeSlots,
  visitType,
  setScheduleData,
  schedule: { time },
  subtitle,
}) {
  const [activeTimeSlot, setActiveTimeSlot] = useState(time);

  usePageView('Get Care | Available Time Slots');

  const handleTimeSelect = timeSlot => {
    setActiveTimeSlot(timeSlot);
  };

  const handleSubmit = () => {
    setScheduleData({ time: activeTimeSlot });
    redirectToAppointmentOverview();
  };

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.timeSlots" />
      <AppointmentHeader
        title={{
          text: `${visitType.name} ${formatMessage({
            id: 'common.visit',
          })}`,
        }}
        subtitle={subtitle}
        handleBack={redirectToAppointmentOverview}
      />

      <Shape className={styles.header}>
        <BackButton onBack={redirectToAppointmentOverview} hasTitle={false} />
        <p>
          {formatMessage({ id: 'appointment.inlineVisit.availableTimeSlots' })}
        </p>
      </Shape>

      <Shape className={styles.content}>
        <div className={styles.slots}>
          <TimeSlots
            variant="sm"
            list={timeSlots}
            onSelect={handleTimeSelect}
            activeSlot={activeTimeSlot}
          />
        </div>
        <Button onClick={handleSubmit} color="primary" raised>
          {formatMessage({ id: 'common.ok' })}
        </Button>
      </Shape>
    </Fragment>
  );
}

AvailableTimeSlots.propTypes = {
  formatMessage: PropTypes.func,
  timeSlots: PropTypes.array,
  visitType: PropTypes.object,
  setScheduleData: PropTypes.func,
  schedule: PropTypes.object,
  subtitle: PropTypes.object,
};

export default enhance(AvailableTimeSlots);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AvailableTimeSlots/index.jsx